import {
  ActionType,
  ITransferCertificateData,
  ScanGeolocationPayload,
} from "./model";

import { createApiCall } from "services";

import type { AxiosResponse } from "axios";
import { call, put, fork, takeLatest } from "redux-saga/effects";
import { CerteficateSettingsProps } from "types/Common";

import { ActionCallback } from "../model";
import { getCookie } from "utils";
import { base64EncodeEmail } from "utils/parsers";

export function* getTabsSummarySaga(): Generator {
  yield takeLatest(
    ActionType.GET_TABSSUMMARY,
    function* (action: ActionCallback) {
      try {
        const { payload, callback } = action;

        const { data, status } = yield call(createApiCall, {
          url: "/certificates/customer/summary",
          params: payload,
        });

        if (status === 200) {
          yield put({
            type: ActionType.SET_TABSSUMMARY,
            payload: data,
          });
        }
      } catch (e) {
        console.warn(e);
      }
    }
  );
}

export function* transferCertificateSaga(): Generator {
  yield takeLatest(
    ActionType.TRANSFER_CERTIFICATE,
    function* (action: ActionCallback<ITransferCertificateData>) {
      const { payload, callback } = action;
      try {
        const { data, status } = yield call(createApiCall, {
          method: "POST",
          url: `/transfer/customer/init/${payload.certificateId}`,
          data: payload,
        });

        if (status === 201 && data) {
        }

        if (callback) {
          callback({ success: status === 201 });
        }
      } catch (e) {
        if (callback) {
          callback({ success: false, text: "Something went wrong!" });
        }
        console.warn(e);
      }
    }
  );
}

export function* confirmTransferCertificateSaga(): Generator {
  yield takeLatest(
    ActionType.CONFIRM_TRANSFER_CERTIFICATE,
    function* (action: ActionCallback<{ certificateId: string }>) {
      const { payload, callback } = action;
      try {
        const response: AxiosResponse = yield call(createApiCall, {
          method: "POST",
          url: `/transfer/customer/confirm/${payload.certificateId}`,
          data: payload,
        });

        const { data, status } = response;

        if (callback) {
          callback({ success: status === 201 });
        }
      } catch (e) {
        if (callback) {
          callback({ success: false, text: "Something went wrong!" });
        }
        console.warn(e);
      }
    }
  );
}

export function* cancelTransferCertificateSaga(): Generator {
  yield takeLatest(
    ActionType.CANCEL_TRANSFER_CERTIFICATE,
    function* (action: ActionCallback<{ certificateId: string }>) {
      const { payload, callback } = action;
      try {
        const response: AxiosResponse = yield call(createApiCall, {
          method: "POST",
          url: `/transfer/customer/cancel/${payload.certificateId}`,
          data: payload,
        });

        const { data, status } = response;

        if (callback) {
          callback({ success: status === 201 });
        }
      } catch (e) {
        if (callback) {
          callback({ success: false, text: "Something went wrong!" });
        }
        console.warn(e);
      }
    }
  );
}

export function* requestCancelTransferCertificateSaga(): Generator {
  yield takeLatest(
    ActionType.REQUEST_CANCEL_TRANSFER_CERTIFICATE,
    function* (action: ActionCallback<{ certificateId: string }>) {
      const { payload, callback } = action;
      try {
        const response: AxiosResponse = yield call(createApiCall, {
          method: "POST",
          url: `/transfer/customer/request-cancel/${payload.certificateId}`,
          data: payload,
        });

        const { data, status } = response;

        if (callback) {
          callback({ success: status === 201 });
        }
      } catch (e) {
        if (callback) {
          callback({ success: false, text: "Something went wrong!" });
        }
        console.warn(e);
      }
    }
  );
}

export function* confirmCancelRequestTransferCertificateSaga(): Generator {
  yield takeLatest(
    ActionType.CONFIRM_CANCEL_REQUEST_TRANSFER_CERTIFICATE,
    function* (action: ActionCallback<{ certificateId: string }>) {
      const { payload, callback } = action;
      try {
        const response: AxiosResponse = yield call(createApiCall, {
          method: "POST",
          url: `/transfer/customer/confirm-cancel-request/${payload.certificateId}`,
          data: payload,
        });

        const { data, status } = response;

        if (callback) {
          callback({ success: status === 201 });
        }
      } catch (e) {
        if (callback) {
          callback({ success: false, text: "Something went wrong!" });
        }
        console.warn(e);
      }
    }
  );
}

export function* rejectCancelRequestTransferCertificateSaga(): Generator {
  yield takeLatest(
    ActionType.REJECT_CANCEL_REQUEST_TRANSFER_CERTIFICATE,
    function* (action: ActionCallback<{ certificateId: string }>) {
      const { payload, callback } = action;
      try {
        const response: AxiosResponse = yield call(createApiCall, {
          method: "POST",
          url: `/transfer/customer/reject-cancel-request/${payload.certificateId}`,
          data: payload,
        });

        const { data, status } = response;

        if (callback) {
          callback({ success: status === 201 });
        }
      } catch (e) {
        if (callback) {
          callback({ success: false, text: "Something went wrong!" });
        }
        console.warn(e);
      }
    }
  );
}

export function* editTransferMetadataSaga(): Generator {
  yield takeLatest(
    ActionType.EDIT_TRANSFER_METADATA,
    function* (action: ActionCallback<{ transferId: string }>) {
      const { payload, callback } = action;
      try {
        const response: AxiosResponse = yield call(createApiCall, {
          method: "PUT",
          url: `/transfer/customer/${payload.transferId}/metadata`,
          data: payload,
        });

        const { data, status } = response;
        if (callback) {
          callback({ success: status === 201 });
        }
      } catch (e) {
        if (callback) {
          callback({ success: false, text: "Something went wrong!" });
        }
        console.warn(e);
      }
    }
  );
}

export function* editCertificateSettingsSaga(): Generator {
  yield takeLatest(
    ActionType.EDIT_CERTIFICATE_SETTINGS,
    function* (
      action: ActionCallback<{
        certificateId: string;
        data: CerteficateSettingsProps;
      }>
    ) {
      const { payload, callback } = action;
      try {
        const response: AxiosResponse = yield call(createApiCall, {
          method: "PUT",
          url: `/certificates/customer/settings/${payload.certificateId}/`,
          data: payload.data,
        });

        const { data, status } = response;

        if (callback) {
          callback({ success: status === 200 });
        }
      } catch (e) {
        if (callback) {
          callback({ success: false, text: "Something went wrong!" });
        }
        console.warn(e);
      }
    }
  );
}

export function* changeCertificateStatusByCustomerSaga(): Generator {
  yield takeLatest(
    ActionType.CHANGE_CERTIFICATE_STATUS_BY_CUSTOMER,
    function* (action: ActionCallback<{ certificateId: string; status: 'lost' | 'stolen' | 'active'; reason?: string }>) {
      const { payload, callback } = action;
      try {
        const response: AxiosResponse = yield call(createApiCall, {
          method: "PATCH",
          url: `/certificates/customer/status/${payload.certificateId}`,
          data: { status: payload.status, reason: payload.reason },
        });

        const { status } = response;

        if (callback) {
          callback({ success: status === 200 });
        }
      } catch (e) {
        if (callback) {
          callback({ success: false, text: "Something went wrong!" });
        }
        console.warn(e);
      }
    }
  );
}

export function* scanGeolocationSaga(): Generator {
  yield takeLatest(
    ActionType.SCAN_GEOLOCATION,
    function* (action: ActionCallback<ScanGeolocationPayload>) {
      const { payload, callback } = action;
      const { certificateId, ...rest } = payload;
      try {
        const response: AxiosResponse = yield call(createApiCall, {
          method: "PUT",
          url: `/scan/location`,
          data: {
            ...rest,
            encodedEmailId: base64EncodeEmail(getCookie("email") ?? ""),
          },
        });

        const { status } = response;

        if (status === 200) {
          yield put({
            type: ActionType.GET_CERTIFICATE_SCAN_HISTORY,
            payload: {
              id: certificateId,
            },
          });
        }

        if (callback) callback({ success: status === 200 });
      } catch (error) {
        if (callback)
          callback({ success: false, text: "Something went wrong!" });
        console.error(error);
      }
    }
  );
}

export default [
  fork(getTabsSummarySaga),
  fork(transferCertificateSaga),
  fork(confirmTransferCertificateSaga),
  fork(cancelTransferCertificateSaga),
  fork(requestCancelTransferCertificateSaga),
  fork(confirmCancelRequestTransferCertificateSaga),
  fork(rejectCancelRequestTransferCertificateSaga),
  fork(editTransferMetadataSaga),
  fork(editCertificateSettingsSaga),
  fork(changeCertificateStatusByCustomerSaga),
  fork(scanGeolocationSaga),
];
